var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairingExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.9 29.8s-.4.8.6 1.8l2.8 2.8c1.6 1.6 2.3.6 3.6-.6 1.3-1.3 2.2-2 .6-3.6l-2.8-2.8c-.9-.9-1.8-.6-1.8-.6M11.8 23.7s.4-.8-.6-1.7l-2.8-2.8c-1.6-1.6-2.3-.6-3.6.6-1.3 1.3-2.2 2-.6 3.6C5.4 24.5 7 26.2 7 26.2c.9.9 1.7.6 1.7.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.1 24l5.6 5.6M11.8 15.1V9.6c0-1.2 1.1-2.2 2.4-2.2h19.7c1.3 0 2.4 1 2.4 2.2v4.3M36.3 20v4.4c0 1.2-1 2.2-2.3 2.2H23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M36.7 19.6h-4.2c-1.3 0-2.4-1.1-2.4-2.4v-.4c0-1.3 1.1-2.4 2.4-2.4h4.2c1.3 0 2.4 1.1 2.4 2.4v.4c0 1.4-1.1 2.4-2.4 2.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 17.3,
    cy: 12.4,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairingExpenses);
export default __webpack_public_path__ + "static/media/pairingExpenses.a10ef13322da0d24cb7f7a99a0a0ec7f.svg";
export { ForwardRef as ReactComponent };